module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.f40ee7e7.webp";